import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useExitIntent } from '@chegg-wt/core/hooks/useExitIntent'
import { AppState } from '@chegg-wt/core/state'
import { SuperAuthIframeOrigin } from '@chegg-wt/core/components/Modals/SuperAuthIFrameModal/types'
import {
  UNLOCK_ACCOUNT_GATE_MODAL,
  PLAGIARISM_SCROLL_MODAL,
} from '@chegg-wt/core/state/modals/constants'
import * as CfcModal from '@chegg-wt/core/components/Modals/UnlockAccountGateModal/types'
import { OpenModalPayload } from '@chegg-wt/core/state/modals/types'
import { UserRole, UserRoles } from '@chegg-wt/core/constants/user'
import {
  toCreateAccountExitPopup,
  toCheckPaperExitPopup,
} from '@chegg-wt/core/state/instrumentation/actions'
import {
  modalSeen,
  StorageType,
} from '@chegg-wt/core/components/Modals/ExitPopupCfcModals/utils'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { userRoleSelector } from '@chegg-wt/core/state/user/selectors'

const session = StorageType.sessionStorage
const local = StorageType.localStorage
const guestExitModalName = SuperAuthIframeOrigin.CFC_VIEWPAGE_EXIT_GUEST
const freeExitModalName = PLAGIARISM_SCROLL_MODAL

interface ExitPopupCfcModalsProps {
  userRole: UserRole
  openModal: (payload: OpenModalPayload) => void
}

export const ExitPopupCfcModals: React.FC<ExitPopupCfcModalsProps> = ({
  userRole,
  openModal,
}) => {
  const { exitTriggered, setExitTriggered } = useExitIntent()

  useEffect(() => {
    const shouldShowGuestExitModal =
      userRole === UserRoles.NOT_LOGGED_IN &&
      exitTriggered &&
      !modalSeen(session).get(guestExitModalName)

    if (shouldShowGuestExitModal) {
      modalSeen(session).set(guestExitModalName)
      setExitTriggered(false)
      openModal({
        name: UNLOCK_ACCOUNT_GATE_MODAL,
        data: {
          titleText: CfcModal.Titles.CREATE_ACCOUNT_CITATIONS,
          titleIconFilename: CfcModal.TitleIconFilenames.SAVE,
          createAccountButtonText: CfcModal.ButtonTexts.CREATE_ACCOUNT,
          origin: guestExitModalName,
        },
        syntheticRouteName: toCreateAccountExitPopup,
      })
    }
  }, [exitTriggered, userRole, openModal, setExitTriggered])

  useEffect(() => {
    const shouldShowFreeExitModal =
      userRole === UserRoles.FREE_USER &&
      exitTriggered &&
      !modalSeen(session).get(freeExitModalName) &&
      !modalSeen(local).get(freeExitModalName)

    if (shouldShowFreeExitModal) {
      modalSeen(session).set(freeExitModalName)
      openModal({
        name: freeExitModalName,
        data: {},
        syntheticRouteName: toCheckPaperExitPopup,
      })
    }
  }, [exitTriggered, userRole, openModal])

  return null
}

const mapDispatchToProps = { openModal }

const mapStateToProps = (state: AppState) => ({
  userRole: userRoleSelector(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExitPopupCfcModals)
